import type { ReactNode } from 'react'

interface ListingSpecCellProps {
  label: string
  valueChip?: ReactNode
  footer?: ReactNode
  children: ReactNode
  tone?: 'storage' | 'year' | 'battery'
}

export default function ListingSpecCell({
  label,
  valueChip,
  footer,
  children,
  tone = 'storage',
}: ListingSpecCellProps) {
  return (
    <div className={`listing-spec-cell listing-spec-cell--${tone}`}>
      <div className="listing-spec-cell__head">
        <span className="listing-spec-cell__title">{label}</span>
        {valueChip ? <div className="listing-spec-cell__value">{valueChip}</div> : null}
      </div>
      <div className="listing-spec-cell__body">{children}</div>
      <div className="listing-spec-cell__footer">
        {footer ?? <span className="listing-spec-cell__footer-spacer" aria-hidden />}
      </div>
    </div>
  )
}
